import(/* webpackMode: "eager", webpackExports: ["PageComponent"] */ "/vercel/path0/app/info/[slug]/component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Center"] */ "/vercel/path0/app/layout-component.tsx");
